import { render, staticRenderFns } from "./DashuH5.vue?vue&type=template&id=15e6398e&scoped=true"
import script from "./DashuH5.vue?vue&type=script&lang=js"
export * from "./DashuH5.vue?vue&type=script&lang=js"
import style0 from "./DashuH5.vue?vue&type=style&index=0&id=15e6398e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e6398e",
  null
  
)

export default component.exports